// src/Section/Home/Terravia.jsx

import React from "react";
import Banner from "../../Section/Home/Banner/banner.jsx";
import Desktop from "../../Media/Header/Desktop/Desktop_Izzi.png";
import Mobile from "../../Media/Header/Mobile/Mobile_Izzi.png";
import About from "../../Section/Detail/about/about.jsx";

import Lokasi from "../../Section/Home/Lokasi/lokasi.jsx";
import Terraviadata from "./Izzi.json";

import logo from "../../Media/RumahLogo/Izzilogo.png";

import Produk from "../../Pages/Izzi/Izzi/Izzi1.jsx";

import Surrounding from "../../Section/Home/surrounding/Surrounding.jsx";

const Terravia = () => {
  return (
    <div>
      <Banner Desktop={Desktop} Mobile={Mobile} />
      <About
        logo={logo}
        judul={Terraviadata.judul}
        Deskripsi={Terraviadata.deskripsi}
      />

      <Produk />

      <Surrounding />

      <Lokasi />
    </div>
  );
};

export default Terravia;
